import type { TasProgramInstanceState } from 'tio-common/types/tuition-assistance';
import type { ChipSignature } from 'tio-ui/components/chip';

const tasProgramInstanceStateBadgeMap: Record<
  string,
  { intent: ChipSignature['Args']['intent']; label: string; labelKey: string }
> = {
  'TAS.ProgramInstanceState.CREATED': {
    intent: 'success',
    label: 'In Progress',
    labelKey: 'common.tas.state_badge.in_progress',
  },
  'TAS.ProgramInstanceState.DRAFT': {
    intent: 'success',
    label: 'In Progress',
    labelKey: 'common.tas.state_badge.in_progress',
  },
  'TAS.ProgramInstanceState.PENDING_PROGRAM_APPROVAL': {
    intent: 'primary',
    label: 'Pending',
    labelKey: 'common.tas.state_badge.pending',
  },
  'TAS.ProgramInstanceState.PROGRAM_APPROVED': {
    intent: 'success',
    label: 'In Progress',
    labelKey: 'common.tas.state_badge.in_progress',
  },
  'TAS.ProgramInstanceState.PROGRAM_NOT_APPROVED': {
    intent: 'danger',
    label: 'Rejected',
    labelKey: 'common.tas.state_badge.rejected',
  },
  'TAS.ProgramInstanceState.PROGRAM_REJECTED': {
    intent: 'danger',
    label: 'Rejected',
    labelKey: 'common.tas.state_badge.rejected',
  },
  'TAS.ProgramInstanceState.PRIMED': {
    intent: 'success',
    label: 'In Progress',
    labelKey: 'common.tas.state_badge.in_progress',
  },
  'TAS.ProgramInstanceState.PENDING_COMPLETION_APPROVAL': {
    intent: 'primary',
    label: 'Pending',
    labelKey: 'common.tas.state_badge.pending',
  },
  'TAS.ProgramInstanceState.COMPLETION_APPROVED': {
    intent: 'success',
    label: 'In Progress',
    labelKey: 'common.tas.state_badge.in_progress',
  },
  'TAS.ProgramInstanceState.COMPLETION_NOT_APPROVED': {
    intent: 'danger',
    label: 'Rejected',
    labelKey: 'common.tas.state_badge.rejected',
  },
  'TAS.ProgramInstanceState.COMPLETION_REJECTED': {
    intent: 'danger',
    label: 'Rejected',
    labelKey: 'common.tas.state_badge.rejected',
  },
  'TAS.ProgramInstanceState.PENDING_WITHDRAWAL_APPROVAL': {
    intent: 'primary',
    label: 'Pending',
    labelKey: 'common.tas.state_badge.pending',
  },
  'TAS.ProgramInstanceState.WITHDRAWAL_APPROVED': {
    intent: 'warning',
    label: 'Withdrawn',
    labelKey: 'common.tas.state_badge.withdrawn',
  },
  'TAS.ProgramInstanceState.WITHDRAWAL_NOT_APPROVED': {
    intent: 'danger',
    label: 'Withdrawal Not Approved',
    labelKey: 'common.tas.state_badge.withdrawal_not_approved',
  },
  'TAS.ProgramInstanceState.WITHDRAWAL_REJECTED': {
    intent: 'danger',
    label: 'Withdrawal Rejected',
    labelKey: 'common.tas.state_badge.withdrawal_rejected',
  },
  'TAS.ProgramInstanceState.COMPLETED': {
    intent: 'success',
    label: 'Completed',
    labelKey: 'common.tas.state_badge.completed',
  },
  'TAS.ProgramInstanceState.WITHDRAWN': {
    intent: 'danger',
    label: 'Withdrawn',
    labelKey: 'common.tas.state_badge.withdrawn',
  },
  'TAS.ProgramInstanceState.ABANDONED': {
    intent: 'danger',
    label: 'Abandoned',
    labelKey: 'common.tas.state_badge.abandoned',
  },
};

export const instanceBadgeState = (state: TasProgramInstanceState, approvalRequired: boolean) => {
  if (!approvalRequired && state === 'TAS.ProgramInstanceState.PENDING_PROGRAM_APPROVAL') {
    return tasProgramInstanceStateBadgeMap['TAS.ProgramInstanceState.PROGRAM_APPROVED'];
  }
  return tasProgramInstanceStateBadgeMap[state];
};
